<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="name"
                        align="center"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        align="center"
                        label="权限说明">
                    </el-table-column>
                    <el-table-column
                        prop="user_count"
                        align="center"
                        label="角色数">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态">
                        <template slot-scope="scope">
                            {{statusList[scope.row.status]}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Roles',
    inject: ['goPage'],
    data () {
        return {
            statusList: ['已启用', '已禁用'],
            lists: []
        }
    },
    mounted () {
        this.getList()
    },
    methods: {
        getList () {
            this.$http.get('/api/user/rbac/rolelist')
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";
    .detail-box {
        margin-top: 20px;
        padding: 0 0 0 0;
        .detail-item {
            padding-left: 0;
        }
    }
</style>
